import React from "react";
import { connect } from "react-redux";

import {
  GridCardWrapper,
  Div,
  StyledMaskContainer
} from "~/src/containers/scheduler/GridCard/grid-card.styles";

import { formatHours } from "../utils";
import { getCardProps } from "../card-styles";

const GridCardContent = ({ shiftData, booking, onClick = { onClick } }) => {
  const cardData = shiftData || booking?.[0];
  const roleName = cardData?.shift?.roleRate?.roleName;
  const isOnCallTimesEnabled = cardData?.shift?.isOnCallTimesEnabled;
  const venueName =
    cardData?.subvenue?.name ||
    cardData?.shift?.subvenue?.name ||
    cardData?.shift?.venue?.name;

  return (
    <GridCardWrapper
      {...getCardProps(
        cardData?.shift,
        cardData?.state === "CANCELLED",
        cardData?.state === "CANCELLED",
        cardData?.state === "RESERVED",
        true
      )}
      key={cardData?.shift?.id}
      onClick={() => onClick(cardData?.shift)}
    >
      <StyledMaskContainer>
        <Div fontSize="12px" textTransform="capitalize">
          {isOnCallTimesEnabled ? "(On Call) " : ""}
          {roleName}
        </Div>
        <Div fontSize="12px" fontWeight="500">
          {formatHours(cardData.shift)}
        </Div>
        <Div fontSize="12px" width="auto">
          {`${venueName} (${cardData?.shift?.sourceAccount.accountName})`}
        </Div>
      </StyledMaskContainer>
    </GridCardWrapper>
  );
};

const mapStateToProps = s => ({
  showCancelledShifts: s.scheduler?.showCancelledShifts
});

export default connect(mapStateToProps)(GridCardContent);
